"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _TextAreaWrapper = _interopRequireDefault(require("./TextAreaWrapper"));

require("../styles/_script.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AutoSaveComponent = (0, _commonReact.requiresPermission)({
  ComponentToRender: _commonReact.Autosave,
  requiredPermission: 'UPDATE'
});

var Script = /*#__PURE__*/function (_Component) {
  _inherits(Script, _Component);

  function Script(props) {
    var _this;

    _classCallCheck(this, Script);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Script).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleFieldChange", (0, _lodash.default)(function (field) {
      return function (value) {
        var inputValue = (0, _getValueFromGenericInput.getStringValueFromGenericInput)(value);

        _this.setState(function (_ref) {
          var script = _ref.script;
          return {
            script: _objectSpread({}, script, _defineProperty({}, field, inputValue))
          };
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "fetchOrganisation", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(organisationId) {
        var getOrganisation, _ref3, data, error, organisationName;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                getOrganisation = _this.props.getOrganisation;
                _context.next = 3;
                return getOrganisation(organisationId);

              case 3:
                _ref3 = _context.sent;
                data = _ref3.data;
                error = _ref3.error;

                if (!error) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", {
                  error: error
                });

              case 8:
                organisationName = data.getOrganisation.name;
                return _context.abrupt("return", {
                  organisationName: organisationName
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleUpdateScript", function (script) {
      var updateScript = _this.props.updateScript;
      return updateScript({
        name: script.name,
        content: script.content
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleButtonClick", function () {
      var hasUpdatePermission = _this.state.hasUpdatePermission;

      if (hasUpdatePermission) {
        return _this.saveAndClose();
      }

      return _this.close();
    });

    _defineProperty(_assertThisInitialized(_this), "saveAndClose", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var script, _ref5, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              script = _this.state.script;

              _this.setState({
                closing: true
              });

              _context2.next = 4;
              return _this.handleUpdateScript(script);

            case 4:
              _ref5 = _context2.sent;
              error = _ref5.error;

              _this.setState({
                closing: false
              });

              if (!error) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                error: error
              }));

            case 9:
              _this.close();

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      var history = _this.props.history;
      history.push('/');
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlurTitle", function () {
      var script = _this.state.script;

      _this.handleUpdateScript(script);
    });

    _this.state = {
      closing: false,
      hasUpdatePermission: false,
      script: void 0,
      organisationName: void 0
    };
    return _this;
  }

  _createClass(Script, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$props, getScript, fetchCollaborationData, _ref6, _ref6$data, script, scriptError, organisationId, _ref7, organisationName, orgError, hasUpdatePermission;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = this.props, getScript = _this$props.getScript, fetchCollaborationData = _this$props.fetchCollaborationData;
                _context3.next = 3;
                return getScript();

              case 3:
                _ref6 = _context3.sent;
                _ref6$data = _ref6.data;
                _ref6$data = _ref6$data === void 0 ? {} : _ref6$data;
                script = _ref6$data.getScript, scriptError = _ref6.error;

                if (!scriptError) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return", void this.setState({
                  error: scriptError
                }));

              case 9:
                if (script) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return", void this.setState({
                  script: script
                }));

              case 11:
                organisationId = script.organisationId;
                _context3.next = 14;
                return this.fetchOrganisation(organisationId);

              case 14:
                _ref7 = _context3.sent;
                organisationName = _ref7.organisationName;
                orgError = _ref7.error;

                if (!orgError) {
                  _context3.next = 19;
                  break;
                }

                return _context3.abrupt("return", void this.setState({
                  error: orgError
                }));

              case 19:
                hasUpdatePermission = (0, _commonReact.hasPermission)('UPDATE', script.permissions);
                fetchCollaborationData(organisationId);
                return _context3.abrupt("return", void this.setState({
                  script: script,
                  hasUpdatePermission: hasUpdatePermission,
                  organisationName: organisationName
                }));

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          script = _this$state.script,
          closing = _this$state.closing,
          error = _this$state.error,
          hasUpdatePermission = _this$state.hasUpdatePermission,
          organisationName = _this$state.organisationName;
      var actionBtnText = hasUpdatePermission ? 'Save and Close' : 'Close';

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      if (script === null) {
        return _react.default.createElement(_commonReact.NotFound, null);
      }

      if (script === void 0 || organisationName === void 0) {
        return _react.default.createElement(_uiKit.Loader, null);
      }

      var resourcePermissions = script.permissions,
          name = script.name,
          content = script.content;
      return _react.default.createElement("div", {
        className: "script page page__full"
      }, _react.default.createElement(AutoSaveComponent, {
        functionToCall: this.handleUpdateScript,
        data: script,
        permissions: resourcePermissions
      }), _react.default.createElement(_commonReact.CollaborationPageHeader, {
        editableTitle: hasUpdatePermission,
        onBlurTitle: this.handleBlurTitle,
        onChangeTitle: this.handleFieldChange('name'),
        title: name || 'Untitled Script',
        titlePlaceHolder: "Untitled Script",
        subtitle: organisationName,
        actionBtnMobileIcon: "exit",
        actionBtnText: actionBtnText,
        actionBtnOnClick: this.handleButtonClick,
        actionBtnBusy: closing,
        actionPopupBackgroundColor: "catSkillWhite"
      }), _react.default.createElement("div", {
        className: "script__container"
      }, _react.default.createElement("div", {
        className: "page__content"
      }, _react.default.createElement(_TextAreaWrapper.default, {
        content: content,
        onChange: this.handleFieldChange('content'),
        hasUpdatePermission: hasUpdatePermission
      }))));
    }
  }]);

  return Script;
}(_react.Component);

var _default = Script;
exports.default = _default;